import request from '@/utils/request'

let StorageApi = {
 /*仓库列表*/
 storagelist(data) {
  return request._get('/shop/plus.storage.storage/index', data);
},
   /*获取仓库设置*/
   getDepot(data) {
    return request._get('/shop/setting.Depot/index', data);
  },
  /*修改仓库设置*/
  setDepot(data) {
    return request._post('/shop/setting.Depot/index', data);
  },
}
export default StorageApi;



// WEBPACK FOOTER //
// ./src/api/storage.js